import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { createHead } from '@vueuse/head'; // Import de la bibliothèque
import ScrollDirective from './directives/scroll';

const head = createHead(); // Création de l'instance head

// Crée l'application Vue
const app = createApp(App);

// Ajoute la directive scroll globalement
app.directive('scroll', ScrollDirective);


app.use(store).use(router).use(head).mount('#app')
